const isDevelopment = typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production';
export const devLogger = {
    log: (...args) => {
        if (isDevelopment)
            console.log(...args);
    },
    warn: (...args) => {
        if (isDevelopment)
            console.warn(...args);
    },
};
